// Hirá: keep the price pill inside the product page Add to cart button in step with the quantity.
// Prices show whole dollars when there are no cents ($45, not $45.00), like the rest of the page.
(() => {
  const formatMoney = (cents, format) => {
    const amount = (cents / 100).toFixed(2);
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('en'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\.00(?=\D*$)/, '');
  };

  const sync = (scope) => {
    const price = scope.querySelector('.hira-atc-price');
    const input = scope.querySelector('input[name="quantity"]');
    if (!price || !input) return;
    const quantity = Math.max(1, parseInt(input.value, 10) || 1);
    const format = price.dataset.moneyFormat || '${{amount}}';
    price.textContent = formatMoney(Math.round(Number(price.dataset.unitCents) * quantity), format);

    const compare = scope.querySelector('.hira-atc-compare');
    const compareAmount = compare?.querySelector('.hira-atc-compare__amount');
    if (compare && compareAmount) {
      compareAmount.textContent = formatMoney(Math.round(Number(compare.dataset.unitCents) * quantity), format);
    }
  };

  document.addEventListener('quantity-selector:update', (event) => {
    if (event.detail?.cartLine) return; // cart drawer quantities, not the product page
    const scope = event.target.closest('.product-details, product-form-component, form');
    if (scope) sync(scope);
  });

  // Typing a number straight into the quantity field
  const onInput = (event) => {
    if (!event.target.matches?.('input[name="quantity"]')) return;
    const scope = event.target.closest('.product-details');
    if (scope) sync(scope);
  };
  document.addEventListener('input', onInput);
  document.addEventListener('change', onInput);

  // Variant changes re-render the buy buttons with the unit price; re-apply the current quantity.
  document.addEventListener('variant:update', () => {
    requestAnimationFrame(() => document.querySelectorAll('.product-details').forEach(sync));
  });
})();

// Sticky gallery (desktop): when the gallery is taller than the window, stick it by its bottom
// edge rather than its top, so the lower images are never hidden while the details scroll.
(() => {
  const media = document.querySelector('.product-information__media');
  if (!media) return;
  const GAP = 24;
  const update = () => {
    const overflow = media.offsetHeight + GAP * 2 - window.innerHeight;
    media.style.setProperty('--hira-gallery-top', `${overflow > 0 ? GAP - overflow : GAP}px`);
  };
  update();
  window.addEventListener('resize', update, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(update).observe(media);
})();

// Demo "Ends in" countdown (Selling out fast bar): counts down to the shopper's local midnight.
(() => {
  const els = document.querySelectorAll('[data-hira-countdown]');
  if (!els.length) return;
  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => {
    const now = new Date();
    const end = new Date(now);
    end.setHours(24, 0, 0, 0);
    const s = Math.max(0, Math.floor((end - now) / 1000));
    const text = `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
    els.forEach((el) => (el.textContent = text));
  };
  tick();
  setInterval(tick, 1000);
})();
